module.exports = __webpack_public_path__ + "img/logo.3afd87e8.png";